import ProposalClientTeamView from "work/proposals/_views/_shared/proposal-client-team-view";
import Proposal from "work/proposals/proposal";

export default function ArchivedProposalClientTeamTab({ proposal }: { proposal: Proposal }) {
  return <ProposalClientTeamView proposal={proposal} canEdit={false} />;
}
